import { message } from 'antd';
import { JobAssignment } from '../hooks/useJobAssignments';

export const exportJobAssignmentsToCSV = (assignments: JobAssignment[], t: (key: string, fallback?: string) => string) => {
    try {
        // Create CSV headers
        const headers = [
            'Recruiter Name',
            'Recruiter Email',
            'Recruiter Company',
            'Job Title',
            'Job Company',
            'Job Department',
            'Job Status',
            'Assignment Status',
            'Target Type',
            'Target Value',
            'Fee Type',
            'Assignment Date'
        ];

        // Convert assignments to CSV rows
        const csvRows = assignments.map(assignment => [
            assignment.recruiter_name,
            assignment.recruiter_email,
            assignment.recruiter_company_name,
            assignment.job_title,
            assignment.job_company_name,
            assignment.job_department || '',
            assignment.job_status,
            assignment.is_active ? 'Active' : 'Inactive',
            assignment.current_target_type || '',
            assignment.current_target_value || '',
            assignment.fee_type || '',
            new Date(assignment.assignment_date).toLocaleDateString()
        ]);

        // Combine headers and data
        const csvContent = [headers, ...csvRows]
            .map(row => row.map(field => `"${String(field).replace(/"/g, '""')}"`).join(','))
            .join('\n');

        // Create and download the file
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');

        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);

            // Generate filename with current date
            const today = new Date().toISOString().split('T')[0];
            link.setAttribute('download', `job-assignments-${today}.csv`);

            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            message.success(t('EXPORT_SUCCESS', 'Job assignments exported successfully'));
        } else {
            throw new Error('Browser does not support file downloads');
        }
    } catch (error) {
        console.error('Export failed:', error);
        message.error(t('EXPORT_ERROR', 'Failed to export job assignments'));
    }
}; 